import { Components, Theme } from '@mui/material'

export const MuiTooltip: Components<Omit<Theme, 'components'>>['MuiTooltip'] = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.futureTheme.bg.inverted,
      color: theme.palette.futureTheme.text.inverted,
      borderRadius: theme.shape['futureTheme.radius-xs'],
      padding: theme.spacing(0.5, 1.5),
      ...theme.typography['futureTheme.small-regular'],
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.futureTheme.bg.inverted,
    }),
    popper: ({ theme }) => ({
      '&[data-popper-placement*="bottom"] .MuiTooltip-tooltip.MuiTooltip-tooltipPlacementBottom': {
        marginTop: theme.spacing(3),
      },
    }),
  },
}
